<template>
    <div class="row">
      <div class="col-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2 col-xl-6 offset-xl-3">
        <card class="card">
          <div class="card-body">
            <div class="text-success text-center" style="font-size:40px;"><span class="ti-check-box"></span></div>
            <h4 class="card-title mb-4 text-center">Λάβαμε την πληρωμή σας</h4>
            <h5 class="text-center text-muted">Σε λίγα λεπτά θα γίνει έλεγχος της πληρωμής και ενεργοποίηση της συνδρομής σας</h5>
          </div>
        </card>
        <div class="text-center"><router-link :to="{path:'/payments'}">μετάβαση στις πληρωμές μου</router-link></div>
      </div>
    </div>
</template>
<script>
export default {
  components: {
    
  },
  data() {
    return {
      
    };
  },
  mounted() {
    
  },
  methods: {
    
  },
};
</script>
<style scoped>
</style>
